import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, ContentChildren, Input, QueryList } from '@angular/core';

import { TabDirective } from './tab.directive';

@Component({
  selector: 'ctr-reusable-tabs',
  imports: [CommonModule, TabDirective],
  templateUrl: './reusable-tabs.component.html',
  styleUrl: './reusable-tabs.component.scss',
})
export class ReusableTabsComponent implements AfterContentInit {
  @Input() title: string | undefined;
  @ContentChildren(TabDirective) tabs: QueryList<TabDirective> | undefined;
  activeTabIndex = 0;

  ngAfterContentInit() {
    if (this.tabs && this.tabs.length > 0) {
      this.activeTabIndex = 0;
    }
  }

  selectTab(index: number) {
    this.activeTabIndex = index;
  }
}
